import React, { useMemo } from 'react';
import { useTheme } from '@material-ui/styles';
import { Link, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import {
    FilledIconButton,
    HomeIcon,
    MessageIcon,
    UserIcon,
    Text,
    ProfileMenuButton,
    ArticleIcon,
    PhoneIcon,
    FileIcon,
} from '../index';

import { SidebarContainer, StyledBottomNavigation, StyledBottomNavigationAction } from './style';

const patientProfileMenu = [
    {
        name: 'record',
        title: 'Medical Record',
        icon: FileIcon,
    },
    {
        name: 'health',
        title: 'Personal Health',
        icon: UserIcon,
    },
    {
        name: 'profile',
        title: 'Edit Profile',
        icon: ArticleIcon,
    },
    {
        name: 'contact',
        title: 'Contact us',
        icon: PhoneIcon,
    },
];

export const Sidebar = () => {
    const location = useLocation();

    const currentPath = useMemo(() => {
        return location.pathname.split('/')[1];
    }, [location]);

    const Routes = [
        {
            name: 'Home',
            path: 'home',
            icon: HomeIcon,
        },
        {
            name: 'Appointment',
            path: `appointment`,
            icon: MessageIcon,
        },
        {
            name: 'My profile',
            path: 'profile',
            icon: UserIcon,
        },
    ];

    return (
        ![undefined, '', 'call', 'groupcall', 'opencall'].includes(currentPath) && (
            <SidebarContainer>
                {Routes.map((route) => (
                    <Link
                        to={`/${route.path}`}
                        style={{
                            width: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            textDecoration: 'none',
                        }}
                        key={route.name}
                    >
                        <FilledIconButton
                            $noShadow
                            $backgroundColor={route.path === currentPath ? 'white' : 'dimBlue'}
                        >
                            <route.icon
                                fill={route.path === currentPath ? 'primaryBlue' : 'white'}
                            />
                        </FilledIconButton>
                        <Text $color={route.path === currentPath ? 'white' : 'dimBlue'}>
                            {route.name}
                        </Text>
                    </Link>
                ))}
            </SidebarContainer>
        )
    );
};

export const BottomNav = () => {
    const theme = useTheme();
    const location = useLocation();

    const currentPath = useMemo(() => {
        return location.pathname.split('/')[1];
    }, [location]);
    const subPath = useMemo(() => {
        return location.pathname.split('/')[2];
    }, [location]);

    const Routes = [
        {
            name: 'Home',
            path: 'home',
            icon: HomeIcon,
        },
        {
            name: 'Appointment',
            path: `appointment`,
            icon: MessageIcon,
        },
        {
            name: 'My profile',
            path: 'profile',
            icon: UserIcon,
        },
    ];

    return (
        <StyledBottomNavigation
            showLabels
            style={{
                display:
                    ['call', 'groupcall', 'opencall'].includes(currentPath) ||
                    ['one', 'group', 'open'].includes(subPath)
                        ? 'none'
                        : 'flex',
            }}
        >
            {Routes.map((route) => (
                <StyledBottomNavigationAction
                    key={route.name}
                    label={route.name}
                    $selected={route.path === currentPath}
                    component={Link}
                    to={`/${route.path}`}
                    icon={
                        <div
                            style={{
                                borderRadius: '25px',
                                height: '28px',
                                width: '28px',
                                padding: '5px',
                                backgroundColor:
                                    route.path === currentPath
                                        ? theme.palette.common.white
                                        : theme.palette.common.dimBlue,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginBottom: '5px',
                            }}
                        >
                            <route.icon
                                fill={route.path === currentPath ? 'primaryBlue' : 'white'}
                            />
                        </div>
                    }
                />
            ))}
        </StyledBottomNavigation>
    );
};

export const ProfileMenu = ({ onSignOut, mobileLayout, mobileS, selectedMenu, onClick }) => {
    return (
        <div
            style={{
                height: '100%',
                width: '100%',
                position: 'relative',
                paddingBottom: '120px',
            }}
        >
            {patientProfileMenu.map((menu) => (
                <ProfileMenuButton
                    key={menu.name}
                    $selected={menu.name === selectedMenu}
                    onClick={() => onClick(menu.name)}
                    style={{ marginBottom: '10px' }}
                    showNextIcon={mobileLayout}
                >
                    <menu.icon fill="black" />
                    <Text style={{ marginLeft: '15px' }}>{menu.title}</Text>
                </ProfileMenuButton>
            ))}
            <ProfileMenuButton
                onClick={onSignOut}
                style={{
                    position: mobileLayout ? 'absolute' : 'static',
                    bottom: 0,
                    left: mobileLayout ? -15 : 0,
                    width: mobileS ? '105vw' : mobileLayout ? '100vw' : '100%',
                    borderRadius: mobileLayout ? 0 : '16px',
                    justifyContent: mobileLayout ? 'flex-start' : 'center',
                    marginTop: '40px',
                    height: '50px',
                }}
            >
                <Text $color="pink">Sign out</Text>
            </ProfileMenuButton>
        </div>
    );
};

ProfileMenu.propTypes = {
    onSignOut: PropTypes.func,
    mobileLayout: PropTypes.bool,
    mobileS: PropTypes.bool,
    selectedMenu: PropTypes.string,
    onClick: PropTypes.func,
};
